export enum BookingDataTypeCanUploadFile {
  service_image = 'service_image',
  service_category_icon = 'service_category_icon',
  banner_image = 'banner_image'
}
